<ng-template #voorwaarden>
    <!-- prettier-ignore -->
    <p>
        Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
        <ins-pdf-link [pdfLink]="documentsEnum.ConditionsBicycleInsurance" pdfLinkTitle="Voorwaarden Fietsverzekering">in onze voorwaarden</ins-pdf-link>.
    </p>
</ng-template>

<ng-container *ngIf="coverageId === coverageIdEnum.Thuisbrengservice">
    <cyno-tabset customClass="tabset tabset--dark">
        <cyno-tab tabTitle="Wel verzekerd" [active]="true">
            <p>
                U wordt maximaal 3x per jaar thuisgebracht na pech. Dit geldt in heel Nederland en zelfs tot maximaal
                30km over de grens.
            </p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Bij een lekke band</list-flat-item>
                <list-flat-item>Bij diefstal van de fiets</list-flat-item>
                <list-flat-item>Bij een ongeluk met de fiets</list-flat-item>
            </list-flat>
            <p>
                Met "thuisgebracht" bedoelen wij dat wij u brengen naar een adres naar keuze in Nederland en tot 30 km
                vanaf de Nederlandse grens. Reisde u samen? Dan brengen wij uw reisgenoten ook "thuis".
            </p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Niet verzekerd">
            <p>Wat is niet verzekerd:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Pech binnen een straal van 2 km van uw woonadres</list-flat-item>
                <list-flat-item>Pech door een lege accu</list-flat-item>
                <list-flat-item>Vaker dan 3x in een jaar gebruik maken van de Thuisbrengservice</list-flat-item>
            </list-flat>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Eigen Risico">
            <p>Uw eigen risico is: €&nbsp;0</p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
    </cyno-tabset>
</ng-container>
